import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'
import _ from "lodash";
import Select from 'react-select';
import MaterialTable, { MTableToolbar } from "material-table";

import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";


function AllInvoiceReport({ id }) {
  const BillingtableRef = React.createRef();
  var contractNumber = "";
  var customerName = "";
  const [loading, setLoading] = useState(false);

  const [selectedValue, setSelectedValue] = useState(null);
  const [options, setOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const [selectedValue2, setSelectedValue2] = useState(null);
  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue2, setValue2] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss.split(",");
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const handleInputChangeData = (value) => {
    setValue2(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptionsData(value, 1);
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputvalue2, currentPage2);
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading2(true);
        const response = await fetch(`${API}contracts/contracts/filter/?id=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading2(false);
    }
  };

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };


  const handleClear = () => {
    setSelectedValue2(null);
    setSelectedValue(null);
    BillingtableRef.current.onQueryChange();
  };

  const handelInputChange = (value) => {
    setInputValue(value);
    setCurrentPage(1);
    setOptions([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(inputValue, currentPage);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading(true);
        const response = await fetch(`${API}parties/party/?customer_name=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
    }
  };

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 10; // Your page size

    while (true) {
      const query = {
        pageSize,
        page: currentPage,
        search: '',
      };

      // Modify the logic here to handle customerName if needed
      let customerName = "";
      if (selectedValue) {
        customerName = selectedValue.customer_name;
      }

      if (selectedValue2) {
        contractNumber = selectedValue2.contract_number
      }
      const url = API + "billing/invoices/?" + "per_page=" + query.pageSize + "&page=" + (query.page + 1) + "&search=" + query.search + "&contractNumber=" + contractNumber + "&customerName=" + customerName + "&contractid=" + undefined;

      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();

        if (result.data.length === 0) {
          break;
        }

        allData = allData.concat(result.data);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }

    return allData;
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
  }, [id]);

  let navigate = useNavigate();
  const handleView = (id, status) => {
    if (status === "Saved" || status === "Completed") {
      navigate("/billing/viewinvoices", { state: id });
    } else {
      navigate("/billing/editinvoices", { state: id });
    }
  };

  const handlePartyView = (id) => {
    navigate("/party/details", { state: id });
  };

  const handleContractView = (id) => {
    navigate("/contract/view", { state: id });
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
        if (columnDef.field === 'total_amount') {
            alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
        } 
        else if (columnDef.field === 'balance_amount') {
            alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
        } 
        else {
            alignmentStyles[index] = { halign: 'left' }; // Left align for other fields
        }
    });
    return alignmentStyles;
}

  return (
    <>
      <div className="page-wrapper">
        <div className="">
          {loading === false ? (
            <div className="row show_contract show_invoice">
              <div className="col-md-12">
                <div className="mb-0">
                  <div className="body">
                    <div className="table-responsive p-0">
                      <MaterialTable
                        tableRef={BillingtableRef}
                        style={{
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        title={<h5>{t("Invoices")}</h5>}
                        columns={[
                          {
                            title: `${t("Invoice Number")}`,
                            field: "invoice_number",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Invoice Number")}
                                </div>{" "}
                                <div
                                  className="hyperlink"
                                  onClick={() =>
                                    handleView(
                                      rowData.id,
                                      rowData.invoice_status
                                    )
                                  }
                                >
                                  {rowData.invoice_number}
                                </div>
                              </>
                            ),
                          },

                          {
                            title: `${t("Transaction Date")}`,
                            field: "creation_date",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Transaction Date")}
                                </div>
                                <div>
                                  {" "}
                                  {Helper.DateNormal(rowData.creation_date)}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Due Date")}`,
                            field: "due_date",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Due Date")}
                                </div>
                                <div>
                                  {" "}
                                  {Helper.DateNormal(rowData.due_date)}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Invoice Amount")}`,
                            field: "total_amount",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                >
                                  {t("Invoice Amount")}
                                </div>
                                <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.total_amount)}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "right",
                            //   fontSize: 12,
                            // },
                          },
                          {
                            title: `${t("Remaining Amount")}`,
                            field: "balance_amount",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                >
                                  {t("Remaining Amount")}
                                </div>{" "}
                                <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                  {Helper.Amount(rowData.balance_amount)}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "right",
                            //   fontSize: 12,
                            // },
                          },
                          {
                            title: `${t("Day Past Due")}`,
                            field: `due_date`,
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Day Past Due")}
                                </div>
                                <div>{rowData.balance_amount === 0 ? '0 days': Helper.DueDays(rowData.due_date)}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Contract No")}`,
                            field: "contract_id.contract_number",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Contract No")}
                                </div>{" "}
                                <div
                                  className="hyperlink"
                                  onClick={() =>
                                    permissionss &&
                                      permissionsArray.includes(
                                        "view_contract"
                                      ) === true
                                      ? handleContractView(rowData.contract_id.id)
                                      : ""
                                  }
                                >
                                  {rowData.contract_id.contract_number}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Customer Name")}`,
                            field: "customer_name",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Customer Name")}
                                </div>
                                <div
                                  className="hyperlink"
                                  onClick={() =>
                                    permissionss &&
                                      permissionsArray.includes(
                                        "view_party"
                                      ) === true
                                      ? handlePartyView(rowData.contract_id.party)
                                      : ""
                                  }
                                >
                                  {rowData.customer_name}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                        ]}
                        // data={items}
                        data={(query) =>
                          new Promise((resolve, reject) => {
                            const { orderBy, orderDirection } = query;

                            if (selectedValue2 && selectedValue) {
                              contractNumber = selectedValue2.contract_number;
                              customerName = selectedValue.customer_name;
                            } else if (selectedValue2) {
                              contractNumber = selectedValue2.contract_number;
                            } else if (selectedValue) {
                              customerName = selectedValue.customer_name;
                            }
                            let url = API + "billing/invoices/?";
                            url += "per_page=" + query.pageSize;
                            url += "&page=" + (query.page + 1);
                            url += "&search=" + query.search;
                            url += `&contractNumber=${contractNumber !== "" ? contractNumber : ""
                              }`;
                            url += `&customerName=${customerName !== "" ? customerName : ""
                              }`;
                            url += `&contractid=undefined`;
                            if (orderBy) {
                              url += `&orderBy=${orderBy.field}`;
                              url += `&orderDirection=${orderDirection}`;
                            }
                            fetch(url, { headers: authHeader() })
                              .then((response) => response.json())
                              .then((result) => {
                                resolve({
                                  data:
                                    query.orderBy && query.orderDirection
                                      ? _.orderBy(
                                        result.data,
                                        [query.orderBy.field],
                                        [query.orderDirection]
                                      )
                                      : result.data,
                                  page: result.page - 1,
                                  totalCount: result.total,
                                });
                              });
                          })
                        }
                        components={{
                          Toolbar: (props) => (
                            <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                              <MTableToolbar {...props} />
                              <span
                                onClick={() => setState({ isPaneOpen: true })}
                                style={{
                                  color: "#b4b7c5",
                                  paddingRight: "1px",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/static/images/ic-filter.svg"
                                  }
                                  alt=""
                                />
                              </span>
                            </div>
                          ),
                        }}
                        options={{
                          headerStyle: {
                            backgroundColor: "white",
                            color: "#245C7F",
                            fontSize: 11,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "#fff" };
                            }
                          },
                          sorting: true,
                          search: true,
                          toolbar: true,
                          paging: true,
                          pageSize: 10, // make initial page size
                          emptyRowsWhenPaging: false, // To avoid of having empty rows
                          pageSizeOptions: [10, 25, 50, 100],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          exportAllData: true,
                          exportButton: true,
                          exportFileName: "Invoice Reports",
                          exportCsv: async (columns, data) => {
                            try {
                              const allData = await fetchAllDataForExport(); // Fetch all data
                              
                              if(selectedValue !== null){
                                var selectedVal = selectedValue.customer_name
                              }
                              if(selectedValue2 !== null){
                                var selectedVal2 = selectedValue2.contract_number
                              }
                              const title = "Invoice Report";
                              const currentDate = new Date().toLocaleDateString();

                              const csvContentWithInfo = `${title}\n ${selectedValue !== null ? `Fiter By Customer Name : ${selectedVal}\n`:''} ${selectedValue2 !== null ? `Fiter By Contract Number : ${selectedVal2}\n`:''} Date: ${currentDate}\n \n\n`;
                              const csvColumns = Helper.visibleColumn(columns);
                              const csvColumnTitles = csvColumns.map(column => column.title);
                              const csvData = allData.map(rowData => {
                                const rowDataArray = csvColumns.map(columnDef => {
                                  if (columnDef.field === "customer_name") {
                                    return rowData.customer_name ? rowData.customer_name : "";
                                  }
                                  else if (columnDef.field === 'creation_date') {
                                    return rowData.creation_date ? Helper.DateNormal(rowData.creation_date)
                                      : "";
                                  }
                                  else if (columnDef.field === 'contract_id.contract_number') {
                                    return rowData.contract_id?.contract_number || ''; // Using optional chaining to handle null or undefined
                                  }
                                  else if (columnDef.field === 'due_date') {
                                    return rowData.due_date ? Helper.DateNormal(rowData.due_date)
                                      : "";
                                  } else if (columnDef.title === 'Day Past Due') {
                                    return rowData.due_date ? Helper.DueDays(rowData.due_date) : ''
                                  }
                                  else {
                                    return rowData[columnDef.field];
                                  }
                                });
                                return rowDataArray;
                              });

                              const csvRows = [csvColumnTitles, ...csvData];
                              const csvContent = `${csvContentWithInfo}${csvRows.map(row => row.join(',')).join('\n')}`;

                              const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                              const link = document.createElement('a');
                              link.href = URL.createObjectURL(blob);
                              link.download = 'Invoice Report.csv';
                              link.style.display = 'none';
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            } catch (error) {
                              console.error("Error exporting CSV:", error);
                            }
                          },
                          exportPdf: async (columns, data) => {
                            const allData = await fetchAllDataForExport(); // Fetch all data
                            if (allData.length === 0) {
                              console.error("No data found for PDF export");
                              return;
                            }
                            const visibleColumns = Helper.visibleColumn(columns);
                            const doc = new jsPDF();

                            doc.setFont("helvetica", "bold");
                            doc.setFontSize(16);

                            const title = "Invoice Report";
                            doc.text(title, 14, 10);

                            doc.setFontSize(12);
                            doc.setFont("helvetica", "normal");
                            const currentDate = new Date().toLocaleDateString();
                            doc.text(`Date : ${currentDate}`, 14, 15);

                            if (selectedValue !== null || selectedValue2 !== null) {
                              const selectedVal = selectedValue?.customer_name;
                              const selectedVal2 = selectedValue2?.contract_number;
                               if(selectedValue !== null & selectedValue2 !== null){
                                doc.text(`Filter By Customer Name and Contract Number : ${selectedVal === 'undefined'?"":selectedVal} and ${selectedVal2 ==='undefined'?"":selectedVal2}`, 14, 20);
                              }
                              else if (selectedValue!==null){
                                doc.text(`Filter By Customer Name : ${selectedVal === 'undefined'?"":selectedVal} `, 14, 20);
                              }
                              else if(selectedValue2!==null){
                                
                                doc.text(`Filter By  Contract Number : ${selectedVal2 === 'undefined'?"":selectedVal2}`, 14, 20);
                              }
                            }

                            const space = 22; // Adjust the space value as needed
                            const tableStartY = 5 + space;
                            const columnTitles = visibleColumns.map(columnDef => columnDef.title);
                            const pdfData = allData.map(rowData =>
                              visibleColumns.map(columnDef => {
                                if (columnDef.field === 'contract_id.contract_number') {
                                  return rowData.contract_id?.contract_number || ''; // Using optional chaining to handle null or undefined
                                }
                                return rowData[columnDef.field];
                              })
                            );
                            const tableData = [columnTitles, ...pdfData];

                            // doc.autoTable({
                            autoTable(doc,{
                              head: [tableData[0]], // Column headers
                              body: tableData.slice(1), // Data excluding headers
                              startY: tableStartY ,
                              columnStyles: getAlignmentStyles(visibleColumns) // Apply column alignment styles

                            });

                            doc.save(`Invoice Report.pdf`);
                          },
                          actionsColumnIndex: -1,
                          columnsButton: true,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ContentLoader
              viewBox="0 0 1000 550"
              backgroundColor="rgba(0,0,0,0.06)"
              foregroundColor="rgba(0,0,0,0.12)"
            >
              <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
              <circle cx="879" cy="123" r="11" />
              <circle cx="914" cy="123" r="11" />
              <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
              <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
              <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
              <circle cx="880" cy="184" r="11" />
              <circle cx="915" cy="184" r="11" />
              <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
              <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
              <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
              <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="242" r="11" />
              <circle cx="916" cy="242" r="11" />
              <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="303" r="11" />
              <circle cx="917" cy="303" r="11" />
              <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
              <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="363" r="11" />
              <circle cx="916" cy="363" r="11" />
              <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="424" r="11" />
              <circle cx="917" cy="424" r="11" />
              <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
              <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
              <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
              <circle cx="882" cy="484" r="11" />
              <circle cx="917" cy="484" r="11" />
              <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
              <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
              <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
              <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
              <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
              <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
              <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
            </ContentLoader>
          )}
        </div>
      </div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={state1.isPaneOpen}
        title="Filter By"
        subtitle=""
        onRequestClose={() => {
          setState({ isPaneOpen: false });
        }}
      >
        <div className="row">
          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">
                {t("Customer Name")}
              </label>
              <div className="col-lg-12">
                <Select
                  value={selectedValue}
                  filterOption={false}
                  options={options}
                  isClearable
                  onInputChange={handelInputChange}
                  getOptionLabel={(options) => options.customer_name}
                  getOptionValue={(options) => options.customer_name}
                  isLoading={isLoading}
                  placeholder={t("Search for Customer(%for All)")}
                  onMenuScrollToBottom={handleMenuScrollToBottomName}
                  onChange={handelChange}
                />
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">
                {t("Contract Number")}
              </label>
              <div className="col-lg-12">
                <Select
                  value={selectedValue2}
                  filterOption={false}
                  options={options2}
                  isClearable
                  onInputChange={handleInputChangeData}
                  getOptionLabel={(options) => options.contract_number}
                  getOptionValue={(options) => options.contract_number}
                  isLoading={isLoading2}
                  placeholder={t("Search for Contract(%for All)")}
                  onMenuScrollToBottom={handleMenuScrollToBottom}
                  onChange={handelChange2}
                />

              </div>
              <input type="hidden" id="contract_status" value="" />
            </div>
          </div>
          <div className="col-xl-12">
            <div className="form-group row">
              <div
                className="col-lg-12 text-left"
                style={{ marginTop: "30px" }}
              >
                <button
                  type="button"
                  className="clearReceipt btn bg-gradient-secondary ms-auto mb-0"
                  onClick={handleClear}
                >
                  {t("RESET")}
                </button>
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="filterReceipt btn btn-primary ms-auto mb-0"
                  onClick={() => Helper.handleSearch(BillingtableRef)}
                >
                  {t("Apply")}
                </button>
                &nbsp;&nbsp;
              </div>
            </div>
          </div>
        </div>
      </SlidingPane>
    </>
  );
}

export default AllInvoiceReport;
